import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ErrorService } from '../../../error.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { NgZone } from '@angular/core';
import { saveTaxBO } from '../taxs-details.modal';
import { ColumnChangeBO } from '../../list/list.model';

@Injectable({
    providedIn: 'root'
})

export class TDService {
    httpOptions = {
        headers: new HttpHeaders({
            "Content-Type": "application/json",
        })
    };

    constructor(private http: HttpClient, public errorService: ErrorService, public toastrService: ToastrService, public zone: NgZone) { }

    saveTax(save: saveTaxBO): Observable<any> {
        let url = "api/Tax/saveTax";
        return this.http.post(url, save, { observe: 'response', responseType: "text" },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    DeleteTax(paramsData: URLSearchParams): Observable<any> {
        let url = "api/Tax/DeleteTax?";
        return this.http.delete(url + paramsData, { observe: 'response', responseType: "text" },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    ////////===========================Column change func==================///
    getcolumwidth(): Observable<any> {
        let url = "api/ColumnChange/getwidth?";
        return this.http.get<any>(url, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    savecolumwidth(list: ColumnChangeBO): Observable<any> {
        let url = "api/ColumnChange/Savewidth?";
        return this.http.post<any>(url, list, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    //==============================get employee permission==========================================//
    getpermission(paramsData: URLSearchParams): Observable<any> {
        let url = "api/FunctionPermission/getfunctionpermissionemployee?";
        return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
}